/**
 * Heuro Cinema - Theme Controller
 * Handles dark/light mode toggling.
 */

import { setGraphDarkMode, restartGraph } from './graph';

let isDarkMode = true;
let graphInitialized = false;

export function setGraphInitialized(initialized: boolean): void {
  graphInitialized = initialized;
}

export function isDark(): boolean {
  return isDarkMode;
}

export function setTheme(dark: boolean): void {
  isDarkMode = dark;
  document.body.classList.toggle('light-mode', !dark);

  const btn = document.getElementById('themeBtn');
  if (btn) {
    btn.textContent = dark ? '\u25D0' : '\u25D1'; // ◐ or ◑
  }

  setGraphDarkMode(dark);
  if (graphInitialized) {
    restartGraph();
  }
}

export function initTheme(): void {
  // Check system preference
  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) {
    setTheme(false);
  } else {
    setTheme(true);
  }

  // Set up toggle button
  const btn = document.getElementById('themeBtn');
  btn?.addEventListener('click', () => setTheme(!isDarkMode));
}